export enum PortActivityTypes {
  LOADING = 'loading',
  DISCHARGE = 'discharge',
  BOTH = 'both',
  ALL = 'all',
  TECHNICAL = 'technical',
  BUNKER_CALL = 'bunker_call',
  SERVICE_CALL = 'service_call',
}
